import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import moment from 'moment';
import { Parser as JSON2CSVParser } from 'json2csv';
import SubHeader from './SubHeader';
import SubscriptionsWithGroups from './SubscriptionsWithGroups';

import './SubscriptionManagerDashboard.css';

@inject('subscriptionsStore', 'commonStore', 'translationsStore', 'filterStore')
@observer
export default class SubscriptionManagerDashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {};
    const { subscriptionsStore, commonStore } = this.props;
    commonStore.setLoading(true);
    setTimeout(() => {
      Promise.all([subscriptionsStore.load()]).then(() => {
        commonStore.setLoading(false);
      });
    }, 200);
  }

  componentDidMount = () => {};

  componentWillUnmount = () => {
    this.props.filterStore.reset();
  };

  onExport = () => {
    const { subscriptionsStore, translationsStore } = this.props;
    const { filtered } = subscriptionsStore;
    if (filtered.length > 0) {
      let numberColumnCounter = 1;
      const fields = [
        {
          label: translationsStore.translate('subscriptionManager.subscriptionTable.headerLabels.number'),
          value: () => numberColumnCounter++
        },
        {
          label: translationsStore.translate('subscriptionManager.subscriptionTable.headerLabels.product'),
          value: row => (!!row.products && !!row.products[0].name ? row.products.map(product => product.name).join(', ') : '-')
        },
        {
          label: translationsStore.translate('subscriptionManager.subscriptionTable.headerLabels.payment'),
          value: row => (!!row.subscriptionType && row.subscriptionType.name ? translationsStore.translate(`subscriptionManager.types.${row.subscriptionType.name}`) : '-')
        },
        {
          label: translationsStore.translate('subscriptionManager.subscriptionTable.headerLabels.endDate'),
          value: row => new Date(row.end_date).toLocaleDateString(undefined, { year: 'numeric', month: '2-digit', day: '2-digit' })
        },
        {
          label: translationsStore.translate('subscriptionManager.subscriptionTable.headerLabels.status'),
          value: row => {
            const status = moment(row.end_date).isBefore(moment())? 'expired' : 'active';
            return translationsStore.translate(`subscriptionManager.statuses.${status}`)
          }
        },
        {
          label: translationsStore.translate('subscriptionManager.subscriptionTable.headerLabels.plate'),
          value: row => row.vehicle? row.vehicle.license_plate : '-'
        },
        {
          label: translationsStore.translate('subscriptionManager.subscriptionTable.headerLabels.imei'),
          value: row => row.installation && row.installation.node && row.installation.node.asset ? row.installation.node.asset.ain : '-'
        }
      ];

      const exportFilename = 'myfleet.csv';
      try {
        const parser = new JSON2CSVParser({ fields, delimiter: ';', withBOM: true });
        const csv = parser.parse(filtered);
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');

        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', exportFilename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (err) {
        console.error(err);
      }
    }
  };

  render() {
    const { subscriptionsStore } = this.props;
    return (
      <div className={`SubscriptionManagerDashboard ${this.props.commonStore.loading || subscriptionsStore.loading ? 'loading' : ''}`}>
        <SubHeader onExportClick={this.onExport} />
        {!(this.props.commonStore.loading || subscriptionsStore.loading) && <SubscriptionsWithGroups subscriptions={subscriptionsStore.filtered} subscriptionsFiltered={subscriptionsStore.filtered} />}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/SubscriptionManagerDashboard/SubscriptionManagerDashboard.js